function SecureImg({ src, fallbackSrc, alt = "", className, loading, fetchPriority, decoding }) {
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading={loading}
      fetchPriority={fetchPriority}
      decoding={decoding}
      onError={(e) => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = fallbackSrc || src;
      }}
    />
  );
}

export default SecureImg;
